module.exports = "/images/64da334-wohler_logo_295x117.png";